var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.958 3.85l-4.553 19.888c-.215.936-1.206 1.419-2.018.974l-5.759-3.15-2.723 4.72c-.74 1.288-2.615.73-2.615-.775v-5.26c0-.408.16-.796.437-1.08L19.95 7.814c-.009-.141-.152-.264-.294-.16L6.263 17.53l-4.5-2.46c-1.052-.578-1.008-2.196.081-2.697L24.03 2.127c1.062-.492 2.205.52 1.928 1.722h0z",
    stroke: "#333",
    strokeWidth: 2
  })));
};

export default SvgTelegram;